module.exports = __webpack_public_path__ + "img/IMG_0374_L_BlackMatted_MockedUp.ff7ea00f.jpg";